import React from "react";
import './About.css'

function About() {

    return(
        <>

        <div className="about_section">
            
            <h1>About</h1> 
            <p>Welcome to Fun-O-Fun Vacation!.......</p>
            <p>Our customers are at the heart of everything we do, and we go the extra mile to exceed their expectations.</p>
            <p>We stay at the forefront of industry trends to bring you the latest and greatest.</p>
            
        </div>

        
        </>
    )
    
}
export default About